module.exports = __webpack_public_path__ + "img/change-img.2b96838f.svg";